import React from 'react';
import { FormDrawer } from './FormDrawer';

export const LogisticsCompleteDeliveryForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  formData = {},
  onChange,
  formError = '',
}) => {
  const outcome = formData?.outcome === 'incidente' ? 'incidente' : 'conforme';
  const sections = [
    {
      key: 'complete',
      title: 'Cierre de la entrega',
      defaultOpen: true,
      fields: [
        {
          key: 'delivery_code',
          label: 'Código Entrega',
          readOnly: true,
        },
        {
          key: 'sale_code',
          label: 'Código Venta',
          readOnly: true,
        },
        {
          key: 'delivered_date',
          label: 'Fecha de recepción',
          type: 'date',
        },
        {
          key: 'outcome',
          label: 'Resultado de la recepción',
          type: 'select',
          options: [
            { value: 'conforme', label: 'Recepción Conforme' },
            { value: 'incidente', label: 'Con Incidente' },
          ],
        },
        {
          key: 'notes',
          label: outcome === 'incidente' ? 'Detalle del incidente' : 'Notas de recepción',
          type: 'textarea',
          fullWidth: true,
          rows: 3,
          placeholder:
            outcome === 'incidente'
              ? 'Describe el incidente (daño, faltante, rechazo, etc.)'
              : 'Observaciones de la recepción (opcional)',
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title="Finalizar entrega"
      subtitle="Registra la recepción conforme o con incidente"
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={520}
      saveLabel={outcome === 'incidente' ? 'Cerrar con incidente' : 'Confirmar recepción'}
    />
  );
};

export default LogisticsCompleteDeliveryForm;
